import { useContext } from "react";
import { HRLocaleContext } from "./HRLocaleProvider";
import tr from "./tr";
import en from "./en";

const BUNDLES = { tr, en };

export default function useHRCopy() {
  const { locale } = useContext(HRLocaleContext);
  return BUNDLES[locale] || BUNDLES.tr;
}
